import { language } from "language/default";
/* eslint-disable no-extend-native */
const quartiles = language.en.widgets.quartileRanking;
export const NARating = quartiles.unknownn;
export const esgScoresWithoutNA = ["AAA", "AA", "A", "BBB", "BB", "B", "CCC", "CC", "C", "D"];
export const quartileWithoutNA = [quartiles.bottom, quartiles.lowerMid, quartiles.upperMid, quartiles.top];
export const esgScores = [...esgScoresWithoutNA, NARating];
export const quartileScores = [NARating, ...quartileWithoutNA];
export const reversedEsgScores = esgScores.slice().reverse();
export const getEsgComparator = function getEsgComparator(selector) {
    return (a, b) => {
        const indexA = esgScores.indexOf(selector(a));
        const indexB = esgScores.indexOf(selector(b));
        if (indexA === indexB) {
            return 0;
        }
        return indexA > indexB ? 1 : -1;
    };
};
export const esgComparator = (a, b) => {
    const indexA = esgScores.indexOf(a);
    const indexB = esgScores.indexOf(b);
    if (indexA === indexB) {
        return 0;
    }
    return indexA > indexB ? 1 : -1;
};
Object.defineProperty(Array.prototype, "sortESG", {
    configurable: true,
    enumerable: false,
    value: function value(selector) {
        const comparator = getEsgComparator(selector);
        return this.sort(comparator);
    },
    writable: true,
});
export const convertToEsgIndexOrNumber = (value) => {
    if (value === null || Array.isArray(value)) {
        return Number.NaN;
    }
    if (!reversedEsgScores.includes(value)) {
        return Number(value);
    }
    if (value === NARating) {
        return null;
    }
    return reversedEsgScores.indexOf(String(value));
};
export const repRiskRatingCamelCase = "repRiskRating";
Object.defineProperty(Array.prototype, "pushIfNotExist", {
    configurable: true,
    enumerable: false,
    value: function value(element, comparer) {
        const shouldPush = comparer ? !this.some(comparer) : !this.includes(element);
        if (shouldPush) {
            return this.push(element);
        }
        return this.length;
    },
    writable: true,
});
Object.defineProperty(Array.prototype, "unshiftIfNotExist", {
    configurable: true,
    enumerable: false,
    value: function value(element, comparer) {
        if (!this.some(comparer)) {
            return this.unshift(element);
        }
        return this.length;
    },
    writable: true,
});
Object.defineProperty(Array.prototype, "toMap", {
    configurable: true,
    enumerable: false,
    value: function value(keySelector, valueSelector) {
        return this.reduce((acc, curr) => {
            const key = keySelector(curr);
            const val = valueSelector(curr);
            if (key && val && !acc.has(key)) {
                acc.set(key, val);
            }
            return acc;
        }, new Map());
    },
    writable: true,
});
Object.defineProperty(Array.prototype, "toRecord", {
    configurable: true,
    enumerable: false,
    value: function value(keySelector, valueSelector) {
        const initial = {};
        return this.reduce((acc, curr) => {
            const key = keySelector(curr);
            const val = valueSelector(curr);
            if (key && val && !acc[key]) {
                acc[key] = val;
            }
            return acc;
        }, initial);
    },
    writable: true,
});
export const getEsgColorIndex = (name) => esgScores.indexOf(name);
